/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 *
 */

export const LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST =
    '@@b2b_portal_ui/widgetSubscriberMobile/LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST';
export const LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS =
    '@@b2b_portal_ui/widgetSubscriberMobile/LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS';
export const LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL =
    '@@b2b_portal_ui/widgetSubscriberMobile/LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL';

export const WIDGET_SUBSCRIBER_MOBILE_REDIRECT =
    '@@b2b_portal_ui/widgetSubscriberMobile/WIDGET_SUBSCRIBER_MOBILE_REDIRECT';
